module.exports = __webpack_public_path__ + "img/threat-analytics-packages-details.8f042b5a.png";